import { parseQueryMethodArguments } from './parse-query-method-arguments.js';

function removeEmptyEntry(...args) {
  const {
    query,
    key,
    value
  } = parseQueryMethodArguments(...args);

  // Remove falsey query params that might cause unneccessary operational load
  if (!value || value === null || value === '' || value === 'undefined') {
    delete query[key];
  }
  return query;
}

export { removeEmptyEntry };
